<div class="invites">

    <div class="invites__filters">
        @if ({ stats: inviteStats$ | async, active: activeFilter$ | async }; as data) {
            @for (chip of filterChips; track chip.key) {
                <button type="button"
                        class="invites__chip"
                        [class.invites__chip--active]="data.active === chip.key"
                        (click)="onFilterSelect(chip.key)">
                    {{ chip.labelKey | translate }}
                    @if (data.stats) {
                        <span class="invites__chip-count">({{ data.stats[chip.statsKey] }})</span>
                    }
                </button>
            }
        }
    </div>

    @if ({ invites: invites$ | async, isLoading: isLoading$ | async }; as data) {
        <app-spinner [isLoading]="data.isLoading" [isFixedPosition]="false">
            <div class="invites__list">
                @for (invite of data.invites; track invite.announcementId) {
                    <a class="invite-card"
                       [class.invite-card--disabled]="invite.announcementStatusId === announcementStatus.Inactive || invite.announcementStatusId === announcementStatus.Expired"
                       [class.invite-card--expired]="invite.announcementStatusId === announcementStatus.Expired"
                       [routerLink]="invite.announcementStatusId === announcementStatus.Inactive ? null : ['/jobseeker/applies/invitations', invite.announcementId]">

                        @if(invite.announcementStatusId === announcementStatus.Expired){
                            <span class="invite-card__badge-expired">{{ 'label.VacancyExpired' | translate }}</span>
                        }
                        @else if(invite.viewStatus === viewStatus.New){
                            <span class="invite-card__badge-new">{{ 'label.New' | translate }}</span>
                        }
                        @else if(invite.viewStatus === viewStatus.Seen && invite.responseStatus === responseStatus.NotResponded){
                            <span class="invite-card__badge-seen">{{ 'label.Seen' | translate }}</span>
                        }

                        <div class="invite-card__logo">
                            @if (invite.logo?.logoThumbnailFilename) {
                                <img class="invite-card__logo-img"
                                     loading="lazy"
                                     [src]="invite.logo.logoThumbnailFilename"
                                     [alt]="invite.customerName">
                            }
                        </div>

                        <div class="invite-card__main">
                            <div class="invite-card__customer">{{ invite.customerName }}</div>
                            <div class="invite-card__title">{{ invite.announcementName }}</div>
                            <div class="invite-card__meta">
                                @if (invite.extendedLocations?.length) {
                                    <hrra-announcement-location class="invite-card__meta-item invite-card__meta-item--location"
                                                                [locations]="invite.extendedLocations"
                                                                [redesign]="true"></hrra-announcement-location>
                                }
                                @if (invite.workSchedule) {
                                    <span class="invite-card__meta-item">{{ invite.workSchedule }}</span>
                                }
                                @for (spec of invite.headSpecializationNames; track $index) {
                                    <span class="invite-card__meta-item">{{ spec }}</span>
                                }
                            </div>
                        </div>

                        <div class="invite-card__side" [ngClass]="{'side-with-no-response': invite.responseStatus === responseStatus.NotResponded, 'side-with-response-and-expired': invite.responseStatus !== responseStatus.NotResponded && invite.announcementStatusId === announcementStatus.Expired}">
                            @if (invite.responseStatus !== responseStatus.NotResponded) {
                                <div class="invite-card__status"
                                     [ngClass]="{
                                        'invite-card__status--interested': invite.responseStatus === responseStatus.Interested,
                                        'invite-card__status--applied': invite.responseStatus === responseStatus.InterestedAndApplied,
                                        'invite-card__status--not-interested': invite.responseStatus === responseStatus.NotInterested,
                                     }">
                                    {{ responseStatusLabelMap[invite.responseStatus] | translate }}
                                </div>
                            }
                            <div class="invite-card__dates">
                                <div class="invite-card__date">{{ 'label.InviteDate' | translate }}: {{ invite.inviteDate | date:'dd/MM/yyyy' }}</div>
                                <div class="invite-card__date">
                                    {{ 'label.VacancyDeadline' | translate }}:
                                    @if (invite.isDeadlineToday) {
                                        <span class="invite-card__deadline--today">{{ 'label.Today' | translate }}</span>
                                    } @else {
                                        <span [class.invite-card__deadline--expired]="invite.announcementStatusId === announcementStatus.Expired">{{ invite.deadline | date:'dd/MM/yyyy' }}</span>
                                    }
                                </div>
                                @if(invite.responseStatus === responseStatus.NotResponded && invite.viewStatus === viewStatus.Seen){
                                 <div class="not-responded">{{'label.InvitationStatusNotResponded' | translate}}</div>
                                }
                            </div>
                        </div>

                        <span class="invite-card__chevron" aria-hidden="true"></span>
                    </a>
                } @empty {
                    @if (data.isLoading === false) {
                        <div class="invites__empty">
                            {{ 'label.NoResults' | translate }}
                        </div>
                    }
                }
            </div>
        </app-spinner>
    }

    @if ({ pageCount: pageCount$ | async, navItems: navItems$ | async, currentPage: currentPage$ | async, active: activeFilter$ | async }; as data) {
        @if (data.pageCount > 1) {
            <div class="invites__paging">
                <app-paging [currentPage]="data.currentPage"
                            [pageCount]="data.pageCount"
                            [pagingNavItems]="data.navItems"
                            (onPageNav)="onPagingNavigation($event, data.active)"></app-paging>
            </div>
        }
    }
</div>
